module.exports = __webpack_public_path__ + "static/img/1.683ad222.png";